import { useState } from 'react'
import { createUseStyles } from 'react-jss'
import { Layout, HomePost, SimpleSlider, Highlight } from '../components/front'
import { getProductCategories, getUniqueProducts, getSlideshows, getStaticDate } from '../lib'
import { useCart } from '../components/front/Cart'

const useStyles = createUseStyles({
    features: {
        backgroundColor: 'var(--lightGray)',
        '& .featureItem': {
            border: '1px',
            borderStyle: 'solid',
            borderColor: '#ecdff7',
            backgroundColor: '#fafafa',
            padding: '10px 10px 10px 50px'
        }
    },
    slideSection: {
        backgroundColor: 'var(--lightGray)'
    }
})

export async function getServerSideProps() {
    const productCategories = await getProductCategories()
    const latestProducts = await getUniqueProducts({ pagesize: 9 })
    const data = await getStaticDate()
    const slideshows = await getSlideshows()
    let slideshowDict = {}
    for (const slide of slideshows)
        if (slideshowDict[slide.category_id]) slideshowDict[slide.category_id].push(slide)
        else slideshowDict[slide.category_id] = [slide]
    return {
        props: {
            productCategories: productCategories,
            latestProducts: latestProducts,
            slideshows: slideshowDict,
            footer: data['about_footer'].content
        }
    }
}

export default function Home({ productCategories, latestProducts, slideshows, footer }) {
    const classes = useStyles()
    const cart = useCart()
    const [moreProducts, setMoreProducts] = useState({ page: 1, pagesize: 9, products: [] })

    async function loadMoreProducts() {
        const response = await fetch('/api/graphql', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                query: `
                query {
                    ents(query: { type: "product", parent_id: null}, meta: { page:${moreProducts.page}, pagesize: ${moreProducts.pagesize}, order: ["availability", "created_at desc"] }) {
                        success
                        entities {
                            id
                            name
                            abst
                            des
                            metas{
                                id
                                key
                                value
                                type
                            }
                            metas_dic
                            content
                            category_id
                            category_name
                            parent_id
                            parent_name
                            children_count
                            stock
                            created_at
                            createdby_id
                            modified_at
                            modifiedby_id
                        }
                    }
                }`
            })
        })
        const responseObj = await response.json()
        for (let ent of responseObj.data.ents.entities) {
            ent.metas_cus = ent.metas.filter((m) => m.type === 'attr_cus')
            for (let meta of ent.metas_cus) {
                meta.created_at += ''
                meta.modified_at += ''
            }
            ent.metas = ent.metas.filter((m) => m.type !== 'attr_cus')
            let dic = {}
            for (let meta of ent.metas) {
                meta.created_at += ''
                meta.modified_at += ''

                dic[meta.key] = meta
            }
            ent.metas = dic
            ent.created_at += ''
            ent.modified_at += ''
        }
        setMoreProducts({
            page: moreProducts.page + 1,
            pagesize: 9,
            products: [...moreProducts.products, ...responseObj.data.ents.entities]
        })
    }

    const produstPosts = latestProducts
        .concat(moreProducts.products)
        .map((product) => (
            <HomePost
                enName={product?.metas?.alt?.value}
                faName={product?.name}
                href={`/products/detail/${product.id}/${encodeURIComponent(product.name)}`}
                imageUrl={product?.metas?.pic_path?.value}
                inCart={cart.exists(product.id)}
                key={product.id}
                product={product}
                stock={product?.stock}
            />
        ))

    return (
        <Layout title="" description="" menu={productCategories} footer={{ about: footer }}>
            <div className={`${classes.slideSection} grid grid-cols-1 lg:grid-cols-3 gap-4`}>
                <div className="lg:col-span-2 mt-2">
                    {slideshows[0] && slideshows[0].length !== 0 && <SimpleSlider items={slideshows[0]}></SimpleSlider>}
                </div>
                <div className="col-span-1 mt-2">
                    <div className="mx-auto p-2 md:pr-16 lg:p-3 lg:h-full">
                        {slideshows[1] && slideshows[1].length !== 0 && (
                            <a href={slideshows[1][0].content}>
                                <img
                                    src={`/api/${slideshows[1][0].metas?.pic_path?.value}`}
                                    className="mb-4 rounded-xl"
                                    alt=""
                                />
                            </a>
                        )}
                        {slideshows[2] && slideshows[2].length !== 0 && (
                            <a href={slideshows[2][0].content}>
                                <img
                                    src={`/api/${slideshows[2][0].metas?.pic_path?.value}`}
                                    className="mb-4 rounded-xl"
                                    alt=""
                                />
                            </a>
                        )}
                    </div>
                </div>
            </div>
            {/* <div className={`${classes.features} grid grid-cols-1  lg:grid-cols-3 p-10 gap-4 border-color`}>
                <ShopFeatures />
            </div> */}
            <div className="col-start-1 col-end-5 p-3 postBody pt-5">
                <h2 className="text-2xl text-center mb-4">دسته بندی محصولات</h2>
                <Highlight items={productCategories}></Highlight>
            </div>
            <h2 className="text-2xl text-center mb-4">جدیدترین محصولات</h2>
            <div className="grid grid-cols-1 p-2 md:grid-cols-2 lg:grid-cols-3 gap-2 postBody">{produstPosts}</div>
            <div className="flex m-4 justify-center">
                <button
                    className="flex message p-2 rounded outline-none focus:outline-none bg-pink-300 mb-1"
                    type="button"
                    onClick={loadMoreProducts}
                >
                    مشاهده بیشتر
                </button>
            </div>
        </Layout>
    )
}
